define.alias("shared/types", "media/types/index");